module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 43300.109da9b1.png";